export default "__VITE_ASSET__DHItcfUb__"